import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Company } from 'src/assets/types/interface/company.interface';
import { PaginatorInterface } from 'src/assets/types/interface/table-items.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private readonly apiUrl = environment.COMPANY_API_URL;
  constructor(private http: HttpClient) {}

  createCompany(data: Company) {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.post(`${this.apiUrl}/company/ `, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      observe: 'response',
    });
  }

  updateCompany(companyUuid: string, data: Company) {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.put(`${this.apiUrl}/company/${companyUuid}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  createCompanyBranch(data: any, companyUuid: string) {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.post(
      `${this.apiUrl}/company/branch/${companyUuid}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        observe: 'response',
      },
    );
  }

  getCompanyByUuid(companyUuid: string): Observable<HttpResponse<Company>> {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.get<Company>(`${this.apiUrl}/company/${companyUuid}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
      observe: 'response',
    });
  }

  getCompanies() {
    const access_token = localStorage.getItem('access_token');

    return this.http.get<any>(`${this.apiUrl}/company/`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getMatriz(access_token: string) {
    return this.http.get<Company>(`${this.apiUrl}/company/matriz/`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getCompanyBranchs(): Observable<Company[]> {
    const access_token = localStorage.getItem('access_token') ?? '';
    return this.http.get<Company[]>(`${this.apiUrl}/company/branchs`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getCompanyBranchsWithPagination(
    take: number,
    page: number,
    filters?: {
      name?: string;
      sectorActivity?: string;
    },
  ): Observable<PaginatorInterface> {
    const access_token = localStorage.getItem('access_token');
    let params = new HttpParams().set('name', filters?.name || '');
    params = params.set('sectorActivity', filters?.sectorActivity || '');

    return this.http.get<PaginatorInterface>(
      `${this.apiUrl}/company/branchs/limit/${take}/page/${page}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
        params,
      },
    );
  }

  getCompanyByAccessToken(
    access_token: string | null | undefined,
  ): Observable<Company> {
    return this.http.get<Company>(`${this.apiUrl}/company/matriz`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
}
